import React from "react";
import PropTypes from "prop-types";
import SolutionCard from "./solutionCard";
import "./_unattachedSolutions.scss";
import { Trans } from "react-i18next";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import Button from "@cx/ui/Button";

const UnattachedSolutions = ({
  unattachedSolutions,
  isAttachingSolutions,
  comingSoonSolutions,
  user,
  ldClient,
  onMergeClick
}) => {
  const getMigratedSolutionIds = () => {
    if (!user.solutionLinks) return [];
    return user.solutionLinks
      .filter((link) => link.isMigrated)
      .map((link) => link.solutionId.toUpperCase());
  };

  const filteredUnattachedSolutions = () => {
    return unattachedSolutions.filter(migratedSolutionFilter);
  };

  const filteredComingSoonSolutions = () => {
    return comingSoonSolutions.filter(migratedSolutionFilter);
  };

  const migratedSolutionFilter = (solution) => {
    if (!solution) return true;
    const solutionId = solution.solutionId || solution.pairedSolution;
    if (solutionId) {
      return !getMigratedSolutionIds().includes(solutionId.toUpperCase());
    } else {
      return true;
    }
  };

  return (
    <div
      id="unattached-solutions-container"
      className="unattached-solutions-container"
    >
      <h1>{<Trans i18nKey="solution-tab.attach-more-solutions-text" />}</h1>
      <ol>
        <li>{<Trans i18nKey="solution-tab.select-solution-text" />}</li>
        <li>{<Trans i18nKey="solution-tab.enter-solution-username-text" />}</li>
      </ol>
      <p>
        {
          <Trans
            i18nKey="solution-tab.attached-solutions-info-text"
            values={{
              username: user.profile.preferredUsername
            }}
          />
        }
      </p>
      <div id="unattached-solution-cards" className="unattached-solution-cards">
        {filteredUnattachedSolutions().map((solution) => (
          <SolutionCard
            key={solution.solutionKey}
            solution={solution}
            attached={false}
            isAttachingSolutions={isAttachingSolutions}
          />
        ))}
        {filteredComingSoonSolutions().map((solution) => (
          <SolutionCard
            key={solution.solutionKey}
            solution={solution}
            attached={false}
            comingSoon={true}
          />
        ))}
      </div>
      {ldClient?.variation("pdt.show-merge-accounts-button", false) && (
        <p className="merge-accounts-text">
          <Trans i18nKey="solution-tab.duplicate-accounts-question" />
          <Button
            htmlId="mergeBridgeAccountsButton"
            buttonStyle="secondary"
            style={{ marginLeft: "8px" }}
            onClick={onMergeClick}
          >
            <Trans i18nKey="common.merge-bridge-accounts" />
          </Button>
        </p>
      )}
    </div>
  );
};

UnattachedSolutions.propTypes = {
  comingSoonSolutions: PropTypes.array.isRequired,
  isAttachingSolutions: PropTypes.array.isRequired,
  ldClient: PropTypes.object,
  onMergeClick: PropTypes.func,
  unattachedSolutions: PropTypes.array.isRequired,
  user: PropTypes.shape({
    profile: PropTypes.shape({
      preferredUsername: PropTypes.string
    }),
    solutionLinks: PropTypes.arrayOf(
      PropTypes.shape({
        solutionId: PropTypes.string,
        isMigrated: PropTypes.bool
      })
    )
  }).isRequired
};

export default withLDConsumer({})(UnattachedSolutions);
